import ListReportController from "ips/ac/controller/scfld/ListReport.controller";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import Item from "sap/ui/core/Item";
import Select, { Select$ChangeEvent } from "sap/m/Select";
import MultiComboBox from "sap/m/MultiComboBox";
import Event from "sap/ui/base/Event";
import CONSTANTS from "ips/ac/util/Constants";
import NoteMetaData from "ips/ac/data/note/definition/NoteMetaData";

/**
 * @namespace ips.ac.data.note.controller
 */
export default class NoteList extends ListReportController {
  public sRouteName = NoteMetaData.ROUTES.list;
  public sEntitySet = NoteMetaData.ENTITY_SET;

  public onAfterRendering() {
    if (this._sRouteName === "notes") {
      this._mapKeyAndInitBox(true);
      this._sortInstanceTypes();
    }
  }

  protected _bindListReportTable() {
    this._alreadyRendered = true;
    this._readCustomFilters().then((data) => {
      const defaultFilter = data["defaultFilter"];
      if (!this._oViewModel.getProperty("/actualFilter")) {
        this._oViewModel.setProperty("/actualFilter", data["actualFilter"]);
      }
      this.getModel("FilterValues").setProperty("/", data["items"]);
      this._setFilterAndSorter(defaultFilter);
      this._mapKeyAndInitBox(true);
    });
  }

  public onFilterInstanceValueBox(event: Select$ChangeEvent) {
    this._mapKeyAndInitBox();
    this.onFilterTable();
  }

  public onResetToAppliedFilter(event?: Event) {
    super.onResetToAppliedFilter(event);
    this._mapKeyAndInitBox();
  }

  private _mapKeyAndInitBox(init?: boolean) {
    const instanceTypeBox = this.byId("InstanceType_Value") as Select;
    const instanceTypeTypeBox = this.byId("InstanceTypeType_Value") as MultiComboBox;
    let value: string;

    switch (instanceTypeBox.getSelectedKey()) {
      case CONSTANTS.INSTANCETYPE.ORDER:
      case CONSTANTS.INSTANCETYPE.ORDER_LINE:
        value = "ORDER_TYPE";
        break;
      case CONSTANTS.INSTANCETYPE.PROJECT:
        value = "CONTAINER_TYPE";
        break;
      case CONSTANTS.INSTANCETYPE.DOCUMENTATION:
        value = "FORM_TYPE";
        break;
      default:
        break;
    }

    if (value) {
      this._bindItemsToMultiComboBox(instanceTypeTypeBox, value, init);
    } else {
      this._hideInstanceTypeTypeFilter(instanceTypeTypeBox);
    }
  }

  private _bindItemsToMultiComboBox(instanceTypeTypeBox: MultiComboBox, value: string, init?: boolean) {
    const alreadySelectedKeys = instanceTypeTypeBox.getSelectedKeys();
    const keys = this._getItemKeys(instanceTypeTypeBox);

    this._oViewModel.setProperty("/showInstanceTypeType", true);
    this._setInstanceTypeTypeLabelText(value);

    instanceTypeTypeBox.bindItems({
      path: "SVH>/",
      template: new Item({
        key: "{SVH>Value}",
        text: "{SVH>TextShort}",
      }),
      filters: [new Filter("Id", FilterOperator.EQ, value)],
    });

    if (!init) {
      const newSelectedKeys = keys.toString() === this._getItemKeys(instanceTypeTypeBox).toString() ? alreadySelectedKeys : [];
      instanceTypeTypeBox.setSelectedKeys(newSelectedKeys);
    }
  }

  private _getItemKeys(multiComboBox: MultiComboBox) {
    return multiComboBox.getItems().map((item) => item.getKey());
  }

  private _setInstanceTypeTypeLabelText(value: string) {
    let labelText: string;

    switch (value) {
      case "ORDER_TYPE":
        labelText = this.getText("@NoteInstanceTypeType_Order");
        break;
      case "CONTAINER_TYPE":
        labelText = this.getText("@NoteInstanceTypeType_Project");
        break;
      case "FORM_TYPE":
        labelText = this.getText("@NoteInstanceTypeType_Documentation");
        break;
      default:
        break;
    }
    this._oViewModel.setProperty("/instanceTypeTypeLabelText", labelText);
  }

  private _hideInstanceTypeTypeFilter(instanceTypeTypeBox: MultiComboBox) {
    instanceTypeTypeBox.removeAllSelectedItems();
    this._oViewModel.setProperty("/showInstanceTypeType", false);
  }

  private _sortInstanceTypes() {
    const select = this.byId("InstanceType_Value") as Select;
    const items = select.getItems();
    const order = [
      CONSTANTS.INSTANCETYPE.PROJECT,
      CONSTANTS.INSTANCETYPE.ORDER,
      CONSTANTS.INSTANCETYPE.ORDER_LINE,
      CONSTANTS.INSTANCETYPE.DOCUMENTATION,
    ];

    select.removeAllItems();
    order.forEach((key) => select.addItem(items.find((item) => item.getKey() === key)));
  }
}
